import React, { Component } from 'react';
import { BasicSetup } from '../../../components/basicsetup/BasicSetup';

class StorageLocationSetup extends Component {
  render() {
    return (
      <BasicSetup
        resourcename="InvGroup/StorageLocation"
        humanname="Storage Location"
        blockEditFromId={99999}
        blockEditToId={99999}
        showId={true}
        showClearFilter={true}
        isHeaderLeftAlign={true}
        {...this.props}
      />
    );
  }
}

export { StorageLocationSetup };



// WEBPACK FOOTER //
// ./src/pages/inventory/storagelocationsetup/StorageLocationSetup.js